import React from "react";
import { EditContentListProps, EditContentListState } from "./models";
import { Box } from "@mui/material";
import { t } from "@lingui/macro";
import { withSnackbar, WithSnackbarProps } from "notistack";
import ZPlayLoader from "commons/zplay-loader";
import { ContentProducerService } from "services/content-producer-service";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";

import { ErrorResponseApi, GetCollectionListResponse } from "models/response";
import { ContentList } from "models";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { CreateAndEditContentList } from "components/backoffice/content-list";
import { EditContentListRequest } from "models/request/edit-content-list-request";
import { EditContentListResponse } from "models/response/edit-content-list-response";
import { ZPlayNetworkService, ZPlayUploadLoader } from "commons";


class EditContentList extends React.Component<EditContentListProps & WithSnackbarProps & RouteComponentProps<any>, EditContentListState> {

    constructor(props: any) {

        super(props);

        this.state = {
            isLoading: true,
            collectionsList: null,
            contentList: null,
            contentListError: false,
            thumbnailFile: null,
            currentUploadPercentage: 0,
            uploadStageMessage: "",
            isUploading: false
        }
    }

    componentDidMount() {
        this.getSingleContentList();
    }

    private getSingleContentList = () => {
        this.setState(() => ({
            isLoading: true,
        }))
        ContentProducerService.getSingleContentList(this.props.match.params.id, this.getContentListSuccessCallback, this.getContentListErrorCallback);
    }

    getContentListSuccessCallback = (data: ContentList) => {
        this.setState(() => ({
            contentList: data,
        }))
        ContentProducerService.getCollectionList(this.getCollectionListSuccessCallback, this.getCollectionListErrorCallback);
    }

    getContentListErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            contentListError: true,
            isLoading: false
        }))
    }

    getCollectionListSuccessCallback = (data: GetCollectionListResponse) => {
        this.setState(() => ({
            collectionsList: data,
            isLoading: false
        }))
    }

    getCollectionListErrorCallback = (err: ErrorResponseApi) => {

        let emptyCollectionList: GetCollectionListResponse = {
            awardList: { list: [], size: 0 },
            countryList: { list: [], size: 0 },
            festivalList: { list: [], size: 0 },
            genreList: { list: [], size: 0 },
            languageList: { list: [], size: 0 },
            tagList: { list: [], size: 0 },
            contentIssuesList: { list: [], size: 0 },
            seriesList: { list: [], size: 0 }
        };

        this.setState(() => ({
            isLoading: false,
            collectionsList: emptyCollectionList,
        }));

        this.props.enqueueSnackbar(t({
            id: "ec-error-get-collection-list-error",
            message: "Si è verificato un errore. Non è stato possibile recuperare i dati"
        }), {
            variant: "error",
        });
    }

    private checkRequest = (request: EditContentListRequest): boolean => {

        if (request.contentList.title.length === 0) {
            this.props.enqueueSnackbar(t({
                id: "ec-no-title-edit-content-list",
                message: "È necessario inserire almeno un titolo"
            }), {
                variant: "error",
            });
            return false
        }

        return true

    }

    private submitForm = (request: EditContentListRequest) => {

        if (!this.checkRequest(request))
            return

        let thumbnailFile = request.thumbnailData;

        this.setState(() => ({
            isLoading: true,
            thumbnailFile: thumbnailFile
        }))

        if (thumbnailFile)
            request.thumbnailData = {
                fileName: thumbnailFile.name,
                format: thumbnailFile.type.split("/")[1]
            };

        ContentProducerService.editContentList(request.contentList.id, request, this.editContentListCallback, this.editContentListErrorCallback);

    };


    editContentListCallback = (data: EditContentListResponse) => {

        if (this.state.thumbnailFile) {
            return this.startThumbUpload(data);
        }

        return this.editContentListSuccessCallback();
    }

    private startThumbUpload = (data: EditContentListResponse) => {

        this.setState(() => ({
            currentUploadPercentage: 0,
            uploadStageMessage: t({
                id: "ce-upload-thumbnail-stage",
                message: "Caricamento della thumbnail in corso..."
            }),
            uploadedContentList: data.contentList,
            isUploading: true,
            isLoading: false,
        }));

        ZPlayNetworkService.xhrMultipartUpload(data.s3PresignedCoverUrl ?? "", this.state.thumbnailFile, this.progressCallback)
            .then(this.confirmThumbUpload)
            .catch(this.editContentListErrorCallback)
    };

    private progressCallback = (percentage: number) => {
        this.setState(() => ({ currentUploadPercentage: percentage }))
    }

    private confirmThumbUpload = () => {

        this.setState(() => ({
            currentUploadPercentage: 0
        }));

        if (this.state.uploadedContentList)
            ContentProducerService.confirmThumbnailUploadContentList(this.state.uploadedContentList.id, this.editContentListSuccessCallback,
                this.editContentListErrorCallback);
    };

    editContentListSuccessCallback = () => {
        this.setState(() => ({
            isLoading: false,
            isUploading: false
        }))

        this.props.enqueueSnackbar(t({
            id: "ec-success-edit-content-list-error",
            message: "La content list è stata aggiornata"
        }), {
            variant: "success",
        })

        this.getSingleContentList();
    }

    editContentListErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            isLoading: false,
            isUploading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ec-error-edit-content-list-error",
            message: "Si è verificato un errore. Non è stato possibile aggiornare la content list"
        }), {
            variant: "error",
        });

    }

    render() {
        return (
            <Box sx={{ p: 5 }}>
                {this.state.isUploading &&
                    <ZPlayUploadLoader progress={this.state.currentUploadPercentage}
                        message={this.state.uploadStageMessage} />}
                {this.state.isLoading && <ZPlayLoader />}
                <NavigationBack />
                {this.state.contentListError && <Redirect to={"/not-found"} />}
                {!this.state.contentListError &&
                    <Box maxWidth={"1000px"} padding={"30px 10px 10px"} margin={"0 auto"}>
                        {!this.state.isLoading &&
                            <CreateAndEditContentList
                                contentList={this.state.contentList}
                                collectionsList={this.state.collectionsList}
                                onSubmit={this.submitForm}
                            />
                        }
                    </Box>}
            </Box>
        );
    }
}

export default withSnackbar(EditContentList);